import React, { FC } from 'react';
import { Box, LottiePlayerECOMMBX } from '@dxb-web-ui-framework/design-system';

// TODO use backdrop component from design-system
const AppLoader: FC = () => (
  <Box display='flex' alignItems='center' justifyContent='center' height='100vh'>
    <LottiePlayerECOMMBX icon='ecommbx_rocket' loop play width={416} height={416} />
  </Box>
);

export { AppLoader };
